import React, { useEffect } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { useTheme } from "../../../utils/ThemeContext";

const SearchInput = ({ value, handleValueChange, placeholder, onKeyDown }) => {
  const handleChange = (event) => {
    handleValueChange(event.target.value);
  };
  const { theme } = useTheme();

  return (
    // Mirrors the dashboard search (DashboardPage .dashboard__search) so every
    // search field across the three frontends looks the same.
    <div className="width-100 search-input">
      <span className="search-input-icon" aria-hidden="true">
        <img
          src={theme === "light" ? icons.search : icons.search_dark}
          alt=""
        />
      </span>
      <input
        type="text"
        className="inria-sans-400"
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

export default SearchInput;
